import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A wooden treasure chest. Single variant, but a ONE-SHOT animation ("open",
// loop: false) that swings the lid up about its rear hinge — the textbook case
// for a non-looping animation and an off-origin pivot. The lid parts are named
// "lid"; the hinge sits at the back-top edge of the body, so the lid rotates
// back rather than around the model centre.
const WOOD = "#7a4a22";
const DARK = "#5a3517";
const IRON = "#3b3b40";
const GOLD = "#d8b24a";

const W = 0.5, D = 0.34;
const BODY_H = 0.26;
const HINGE_Y = BODY_H;
const HINGE_Z = -D / 2;

function band(x: number): Part {
  return { geometry: new THREE.BoxGeometry(0.04, BODY_H + 0.02, D + 0.02), color: IRON, position: [x, BODY_H / 2, 0] };
}

// The domed lid, authored in place; named "lid" so the open track drives it.
function lid(): Part[] {
  return [
    { geometry: new THREE.BoxGeometry(W, 0.06, D), color: WOOD, position: [0, BODY_H + 0.03, 0], name: "lid" },
    { geometry: new THREE.CylinderGeometry(D / 2, D / 2, W, 12, 1, false, 0, Math.PI), color: DARK,
      position: [0, BODY_H + 0.06, 0], rotation: [0, 0, Math.PI / 2], name: "lid" },
    { geometry: new THREE.BoxGeometry(0.06, 0.06, 0.04), color: GOLD, position: [0, BODY_H + 0.1, D / 2], name: "lid" },
  ];
}

export const chest = defineModel({
  id: "chest",
  tiles: { w: 1, h: 1 },
  batchId: "standard",
  name: "Treasure chest",
  tags: ["prop", "container", "animated", "medieval"],
  summary: "A banded wooden chest whose lid swings open.",
  author: "age-of-mcp",
  footprint: 0.3,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(W, BODY_H, D), color: WOOD, position: [0, BODY_H / 2, 0] },
      band(-W / 2 + 0.05),
      band(W / 2 - 0.05),
      { geometry: new THREE.BoxGeometry(0.08, 0.08, 0.03), color: GOLD, position: [0, BODY_H / 2, D / 2 + 0.005] },
      ...lid(),
    ];
  },
  animations: [
    {
      id: "open",
      label: "Open lid",
      duration: 0.9,
      loop: false,
      tracks: [
        {
          target: "lid",
          pivot: [0, HINGE_Y, HINGE_Z],
          rotation: [
            { t: 0, value: [0, 0, 0] },
            { t: 0.9, value: [-1.9, 0, 0], ease: "easeOut" },
          ],
        },
      ],
    },
  ],
});
